import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  span,
  svg {
    color: #666;
  }

  a.active {
    span,
    svg {
      color: ${darken(0.2, '#3f51b5')};
    }
  }
`;
